"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiddleEllipsisLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _MiddleEllipsisLabelModule = _interopRequireDefault(require("./MiddleEllipsisLabel.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MiddleEllipsisLabel = _ref => {
  let {
    text,
    tailLength = 4
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _MiddleEllipsisLabelModule.default["middle-ellipsis-label"]
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _MiddleEllipsisLabelModule.default["head"]
  }, text?.slice(0, text.length - tailLength)), /*#__PURE__*/_react.default.createElement("span", {
    className: _MiddleEllipsisLabelModule.default["tail"]
  }, text?.slice(text.length - tailLength)));
};
exports.MiddleEllipsisLabel = MiddleEllipsisLabel;